import React from "react";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {Badge, Box, Container, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography} from "@mui/material";
// import {Box, Container, Divider, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Typography} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
// import FmdGoodIcon from "@mui/icons-material/FmdGood";
import SlideDatepicker from "./partial/SlideDatepicker";
import {getDaySchedule} from "../api/client";
import "swiper/css";

export default function DaySchedule(props) {
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    date: sessionStorage.getItem("day_schedules_date") || moment().format("yyyy-MM-DD"),
    stopRender: true,
  });
  // const showMap = (place) => {
  //   if (place) {
  //     window.open("https://www.google.co.jp/maps/place/" + place);
  //   };
  // };

  React.useEffect(() => {
    sessionStorage.removeItem("message");
    sessionStorage.removeItem("error");
    sessionStorage.removeItem("instructions");
    sessionStorage.setItem("day_schedules_date", state.date);
    if (Boolean(state.stopRender) && new Date(state.date).toLocaleDateString() !== "Invalid Date") {
      getDaySchedule({ymdDt: state.date}).then(response => {
        setState({...state, data: response.data, stopRender: false});
      }).catch(error => {
        if (Boolean(error.response && error.response.data)) {
          setState({...state, data: [], stopRender: true});
          navigate("/", {state: error.response.data.message});
        } else {
          props.setToastState({...props.toastState, message: null, error: true, networkError: true});
        }
      });
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.stopRender, state.date]);

  return (
    <Container
      className = {state.date < moment().format("yyyy-MM-DD") ? "bgcolor-blue" : moment().format("yyyy-MM-DD") < state.date ? "bgcolor-red" : ""}
      sx = {{position: "relative", minHeight: "100%", width: "100%", p: 0, flexGrow: 1}}
    >
      <Container
        maxWidth = "sm"
        sx = {{p: 2}}
      >
        <Box
          position = "relative"
          sx = {{textAlign: "center"}}
        >
          <SlideDatepicker
            setState = {setState}
            state = {state}
            ymdFg = {true}
          />
          {!Boolean(state.stopRender) ?
          <List
            sx = {{m: "auto"}}
          >
            {state.data.map((item, i) => (
              <Box
                key = {"tl_" + i}
              >
                <Divider
                  variant = "inbox"
                  component = "li"
                />
                <ListItem
                  alignItems = "flex-start"
                  className = "bgcolor-white-half"
                  sx = {{mt: 1, mb: 1, pt: 0, pb: 0}}
                >
                  <ListItemButton
                    onClick = {() => navigate("/instructions", {state: {data: state.data[i], st004200Slug: state.data[i].st004200Slug, date: state.date, sendMailFg: false, stopRender: true}})}
                    sx = {{pr: 1}}
                  >
                    <ListItemText
                      primary = {
                        <React.Fragment>
                          {Boolean(parseInt(item.adminCheckFg)) &&
                          <Box
                            className = "btn-select"
                            sx = {{width: "fit-content", mb: 0.5}}
                          >
                            <Typography>
                              管理者確認済
                            </Typography>
                          </Box>}
                          {!Boolean(parseInt(item.adminCheckFg)) && parseInt(item.status) === 2 &&
                          <Box
                            className = "btn-select"
                            sx = {{width: "fit-content", mb: 0.5}}
                          >
                            <Typography>
                              実施済
                            </Typography>
                          </Box>}
                          {parseInt(item.status) > 2 &&
                          <Box
                            className = "btn-caution"
                            sx = {{width: "fit-content", mb: 0.5}}
                          >
                            <Typography>
                              キャンセル
                            </Typography>
                          </Box>}
                          {!Boolean(item.timelessOtherFg) &&
                          <Typography>
                            {item.timeKb}：{(item.timef || "--:--") + "～" + (item.timet || "--:--")}
                          </Typography>}
                        </React.Fragment>
                      }
                      secondary = {
                        <React.Fragment>
                          <Typography
                            sx = {{display: "inline"}}
                          >
                            {item.nm || "--"}
                          </Typography>
                          <br></br>
                          <Typography
                            sx = {{display: "inline"}}
                          >
                            {item.svRnm || "--"}
                          </Typography>
                        </React.Fragment>
                      }
                      secondaryTypographyProps = {{component: "div", sx: {mt: 1}}}
                    />
                    <ListItemIcon
                      sx = {{minWidth: 0}}
                    >
                      <Badge
                        anchorOrigin = {{vertical: "bottom", horizontal: "right"}}
                        // color = "accentM"
                        // color = "error"
                        sx={{
                          '& .MuiBadge-badge': {
                            backgroundColor: theme => theme.palette.accentM.main,
                            color: 'accentM',
                          },
                        }}
                        invisible = {item.instructionsFg === "1"}
                        variant = "dot"
                      >
                        <EditIcon
                          color = "primary"
                        />
                      </Badge>
                    </ListItemIcon>
                  </ListItemButton>
                  {/* <IconButton
                    color = "accentM"
                    onClick = {() => showMap(item.address)}
                    sx = {{m: "auto", ml: 0.2, borderRadius: 0}}
                  >
                    <FmdGoodIcon />
                  </IconButton> */}
                </ListItem>
              </Box>
            ))}
            <Divider
              variant = "inbox"
              component = "li"
            />
            {state.data.length === 0 &&
            <Typography
              sx = {{pt: 1}}
            >
              訪問予定なし
            </Typography>}
          </List>
          : null}
        </Box>
      </Container>
    </Container>
  );
};
